import { keepPreviousData } from '@tanstack/react-query';
import { AGGREGATE_NAMES, LOAN_REQUEST_RESOLVERS } from 'cpool-constants';
import { schemaLoanRequestResolver_GetUnreadConsorsNotes } from 'cpool-tables/backend-resolvers';

import { useAggregateQuery } from '~/queryUtils/useQuery';
import { useQueryPositionStore } from '~/store/queryPositionStore';
import { queryKeys } from '~/utils/queryKeys';

export const useUnreadConsorsNotes = () => {
    const queryKey = queryKeys.getUnreadConsorsNotes();
    const queryPosition = useQueryPositionStore((state) => state.positions[JSON.stringify(queryKey)]);

    return useAggregateQuery({
        acl: {},
        aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
        resolverName: LOAN_REQUEST_RESOLVERS.getUnreadConsorsNotes,
        schema: schemaLoanRequestResolver_GetUnreadConsorsNotes,
        searchParams: { position: queryPosition },
        tanstack: {
            placeholderData: keepPreviousData,
        },
    });
};
